<template>
  <div>
    <div :class="'sidebar-menu  animated  ' + fadeAnimated">
      <!-- HEADER -->
      <!--        <div class="header-top bg-white">-->
      <!--            <div class="header-top&#45;&#45;inner w-limit d-flex justify-content-between align-items-center">-->
      <!--                <div class="header-top&#45;&#45;left">-->
      <!--                    <div class="header-item">-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--                <div class="header-top&#45;&#45;middle f-cont f-16 f-bold">Menu</div>-->
      <!--                <div class="header-top&#45;&#45;right" @click="$parent.closeMenu()">-->
      <!--                    <div class="header-item">-->
      <!--                        <img src="../../assets/icons/closeblue.svg" alt="a" >-->

      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
      <!--        </div>-->

      <ul class="sidebar-parent w-limit">
        <li
          v-for="(item, index) in items"
          v-bind:class="item.path + ' sidebar-menu-item'"
          :key="`itemFirst${index}`"
        >
          <a :href="item.path" @click.prevent="add($event)">
            <div
              class="d-grid-12 p-x-20 p-y-16 menu-box-text"
              @click="clickItem(index, item)"
            >
              <div class="grid-cspan-1 a-self-center">
                <div class="sidebar-menu-icon">
                  <img
                    class="notification-icon"
                    :src="getImgUrl(item.icon)"
                    v-bind:alt="item.icon"
                  />
                </div>
              </div>
              <div class="grid-cspan-1 a-self-center"></div>
              <div class="grid-cspan-9 a-self-center">
                <div class="sidebar-menu-text">
                  {{ item.text }}
                  <span class="new-menu-flag" v-if="item.isNew && !item.active"
                    >Baru</span
                  >
                </div>
              </div>
              <div class="grid-cspan-1 a-self-center">
                <div class="sidebar-menu-chevron" v-if="item.children">
                  <img
                    v-if="item.active"
                    class="notification-icon rotate down"
                    src="../../assets/icon-sidebar/chevron-down.svg"
                  />
                  <img
                    v-else
                    class="notification-icon rotate"
                    src="../../assets/icon-sidebar/chevron-down.svg"
                  />
                </div>
              </div>
            </div>
          </a>
          <transition name="slide-fade">
            <ul
              class="sidebar-parent second-level"
              v-if="item.children && item.active"
            >
              <template v-for="(itemSecond, indexSecond) in item.children">
                <li
                  v-if="isShowBeta(itemSecond)"
                  class="sidebar-menu-item"
                  :key="`itemSecond${indexSecond}`"
                >
                  <a :href="itemSecond.path" @click.prevent="add($event)">
                    <div
                      class="d-grid-12 p-x-20 p-y-16 menu-box-text"
                      @click="clickItem(indexSecond, itemSecond)"
                    >
                      <div class="grid-cspan-1 a-self-center">
                        <div class="sidebar-menu-icon">
                          <img
                            class="notification-icon"
                            :src="getImgUrl(itemSecond.icon)"
                            v-bind:alt="itemSecond.icon"
                          />
                        </div>
                      </div>
                      <div class="grid-cspan-1 a-self-center"></div>
                      <div class="grid-cspan-9 a-self-center">
                        <div class="sidebar-menu-text">
                          {{ itemSecond.text }}
                          <span
                            class="new-menu-flag"
                            v-if="itemSecond.isNew && !itemSecond.active"
                            >Baru</span
                          >
                        </div>
                      </div>
                      <div class="grid-cspan-1 a-self-center">
                        <div
                          class="sidebar-menu-chevron"
                          v-if="itemSecond.children"
                        >
                          <img
                            v-if="itemSecond.active"
                            class="notification-icon rotate down"
                            src="../../assets/icon-sidebar/chevron-down.svg"
                          />
                          <img
                            v-else
                            class="notification-icon rotate"
                            src="../../assets/icon-sidebar/chevron-down.svg"
                          />
                        </div>
                      </div>
                    </div>
                  </a>

                  <transition name="slide-fade">
                    <ul
                      class="sidebar-parent third-level"
                      v-if="itemSecond.children && itemSecond.active"
                    >
                      <li
                        v-for="(itemThird, indexThird) in itemSecond.children"
                        class="sidebar-menu-item"
                        :key="`itemThird${indexThird}`"
                      >
                        <a :href="itemThird.path" @click.prevent="add($event)">
                          <div
                            class="d-grid-12 p-x-20 p-y-16 menu-box-text"
                            @click="clickItem(indexThird, itemThird)"
                          >
                            <div class="grid-cspan-1 a-self-center">
                              <div class="sidebar-menu-icon">
                                <img
                                  class="notification-icon"
                                  :src="getImgUrl(itemThird.icon)"
                                  v-bind:alt="itemThird.icon"
                                />
                              </div>
                            </div>
                            <div class="grid-cspan-1 a-self-center"></div>
                            <div class="grid-cspan-10 a-self-center">
                              <div class="sidebar-menu-text">
                                {{ itemThird.text }}
                                <span
                                  class="new-menu-flag"
                                  v-if="itemThird.isNew"
                                  >Baru</span
                                >
                              </div>
                            </div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </transition>
                </li>
              </template>
            </ul>
          </transition>
        </li>
      </ul>
    </div>

    <!-- NAVBAR BOTTOM -->
    <div id="nav-bottom">
      <div class="nav-overlay"></div>
      <nav class="nav-bottom--inner">
        <div class="navbar-wrapper w-limit">
          <ul class="navbar-container">
            <!-- Navbar Items / Menu Lists -->
            <li class="navbar-item dashboard" @click="clickMenu('dashboard')">
              <div class="menu-icon">
                <img src="../../assets/icons-menubar/beranda.svg" alt="" />
                <img
                  src="../../assets/icons-menubar/beranda-active.svg"
                  alt=""
                />
              </div>
              <div class="menu-label">Depan</div>
            </li>
            <li
              class="navbar-item karyawan onboarding-karyawan"
              @click="clickMenu('karyawan')"
            >
              <div class="menu-icon">
                <img src="../../assets/icons-menubar/karyawan.svg" alt="" />
                <img
                  src="../../assets/icons-menubar/karyawan-active.svg"
                  alt=""
                />
              </div>
              <div class="menu-label">Karyawan</div>
            </li>
            <li class="navbar-item menu-menu" @click="toogleMenu">
              <div class="menu-bar-wrapper">
                <div class="menu-bar">
                  <img
                    class="menu-label--closed"
                    src="../../assets/icons-menubar/menu-bar-w.svg"
                    alt=""
                  />
                  <img
                    class="menu-label--opened"
                    src="../../assets/icons-menubar/menu-close-w.svg"
                    alt=""
                  />
                </div>
              </div>
              <div class="menu-label">
                <div class="menu-label--closed">Menu</div>
                <div class="menu-label--opened">Tutup</div>
              </div>
            </li>
            <li
              class="navbar-item addoutlet onboarding-outlet"
              @click="clickMenu('addOutlet')"
            >
              <div class="menu-icon">
                <img src="../../assets/icons-menubar/outlet.svg" alt="" />
                <img
                  src="../../assets/icons-menubar/outlet-active.svg"
                  alt=""
                />
              </div>
              <div class="menu-label">Outlet</div>
            </li>
            <li class="navbar-item bantuan" @click="contactCS()">
              <div class="menu-icon">
                <img src="../../assets/icons-menubar/bantuan.svg" alt="" />
                <img
                  src="../../assets/icons-menubar/bantuan-active.svg"
                  alt=""
                />
              </div>
              <div class="menu-label">Bantuan CS</div>
            </li>
            <!--                        <li class="navbar-item pelanggan">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/pelanggan.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/pelanggan-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Pelanggan-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item penggajian" @click="penggajian">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/penggajian.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/penggajian-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Penggajian-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item transaksi">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/transaksi.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/transaksi-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Transaksi-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item pembatalan">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/pembatalan.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/pembatalan-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Pembatalan-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item keuangan" @click="ibos">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/keuangan.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/keuangan-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Keuangan-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item pengiriman">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/pengiriman.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/pengiriman-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Pengiriman-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item aset">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/aset.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/aset-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Aset-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item info-promo">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/info.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/info-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Info & Promo-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item performa">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/performa.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/performa-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Performa-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item suplai">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/suplai.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/suplai-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Suplai-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item fitur-khusus">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/fiturkhusus.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/fiturkhusus-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Fitur Khusus-->
            <!--                            </div>-->
            <!--                        </li>-->
            <!--                        <li class="navbar-item user-profile" @click="menu">-->
            <!--                            <div class="menu-icon">-->
            <!--                                <img src="../../assets/icons-menubar/akun.svg" alt="">-->
            <!--                                <img src="../../assets/icons-menubar/akun-active.svg" alt="">-->
            <!--                            </div>-->
            <!--                            <div class="menu-label">-->
            <!--                                Akun-->
            <!--                            </div>-->
            <!--                        </li>-->
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomMenu",
  data() {
    return {
      requestHeaders: {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      },
      show_menu: false,
      fadeAnimated: "",
      device: "mobile",
      owner: null,
      items: [
        {
          icon: "menu-icon",
          text: " Pindah ke dashboard",
          path: "switchToBeta",
        },
        {
          icon: "akun",
          text: "Profil Akun",
          path: "detailakunowner",
        },
        // {
        //     icon: 'bell',
        //     text: 'Notifikasi',
        //     path: 'notifikasi'
        // },
        {
          icon: "koin",
          text: "Pembelian Dan Pembayaran Smartlink",
          path: "",
          children: [
            {
              icon: "chevron",
              text: "Koin",
              path: "",
              children: [
                {
                  icon: "chevron",
                  text: "Informasi Saldo",
                  path: "ibos",
                  query: {
                    part: "koin/info",
                  },
                },
                {
                  icon: "chevron",
                  text: "Beli Koin",
                  path: "ibos",
                  query: {
                    part: "koin/beli/create",
                  },
                },
                {
                  icon: "chevron",
                  text: "History Pembelian Koin",
                  path: "ibos",
                  query: {
                    part: "koin/beli",
                  },
                },
              ],
            },
            {
              icon: "chevron",
              text: "Aktivasi Outlet",
              path: "ibos",
              query: {
                part: "outlet/outlet/inactive",
              },
            },
            {
              icon: "chevron",
              text: "Status Pengiriman Paket",
              path: "ibos",
              query: {
                part: "koin/bundling",
              },
            },
            {
              icon: "chevron",
              text: "Pemesanan App Konsumen (Whitelabel)",
              path: "whitelabel",
            },
          ],
        },
        {
          icon: "fitur-premium",
          text: "Fitur Khusus",
          isNew: true,
          path: "",
          children: [
            {
              icon: "chevron",
              text: "Nomor Nota Premium",
              path: "ibos",
              query: {
                part: "addons",
              },
            },
            {
              // betaKey: "INVOICE",
              icon: "chevron",
              text: "Faktur Tagihan Masal",
              isNew: true,
              children: [
                {
                  icon: "chevron",
                  text: "List Tagihan Massal",
                  isNew: true,
                  path: "invoice.list",
                },
                {
                  icon: "chevron",
                  text: "Penjadwalan Otomatis",
                  isNew: true,
                  path: "invoicePenjadwalan",
                },
              ],
            },
            // {
            //   icon: "chevron",
            //   text: "Faktur Tagihan Versi Lama",
            //   path: "ibos",
            //   query: {
            //     part: "addons",
            //   },
            // },
            {
              icon: "chevron",
              text: "WhatsApp Autosender",
              path: "",
              isNew: true,
              children: [
                {
                  icon: "chevron",
                  text: "Perangkat WhatsApp",
                  isNew: true,
                  path: "wa_autosender.welcome_page",
                },
                {
                  icon: "chevron",
                  text: "Blast WhatsApp",
                  isNew: true,
                  path: "wa_blast.list",
                },
                /*
                  {
                    icon: "chevron",
                    text: "Status WhatsApp",
                    isNew: true,
                    path: "wa_status.list",
                  },
*/
                // {
                //   icon: "chevron",
                //   text: "Nomor Auto Sender",
                //   path: "ibos",
                //   query: {
                //     part: "addons/wa/config-whatsapp",
                //   },
                // },
                // {
                //   icon: "chevron",
                //   text: "Pengaturan Pesan",
                //   path: "ibos",
                //   query: {
                //     part: "addons/wa/config-pesan",
                //   },
                // },
              ],
            },
            // {
            //   icon: "chevron",
            //   text: "SMS Auto Sender",
            //   path: "ibos",
            //   query: {
            //     part: "addons/sms",
            //   },
            // },

            // {
            //   icon: "chevron",
            //   text: "Blast Whatsapp",
            //   path: "",
            //   children: [
            //     {
            //       icon: "chevron",
            //       text: "Kirim Pesan Blast WA",
            //       path: "ibos",
            //       query: {
            //         part: "konsumen/blastwa/create_blast",
            //       },
            //     },
            //     {
            //       icon: "chevron",
            //       text: "Template Pesan",
            //       path: "ibos",
            //       query: {
            //         part: "konsumen/blastwa/template_list",
            //       },
            //     },
            //     {
            //       icon: "chevron",
            //       text: "Status & Riwayat",
            //       path: "ibos",
            //       query: {
            //         part: "konsumen/blastwa/history",
            //       },
            //     },
            //   ],
            // },
          ],
        },
        {
          icon: "paylink",
          text: "Paylink",
          path: "",
          children: [
            {
              icon: "chevron",
              text: "Informasi Saldo",
              path: "ibos",
              query: {
                part: "paylink/info/v2",
              },
            },
            {
              icon: "chevron",
              text: "Isi Saldo",
              path: "ibos",
              query: {
                part: "paylink/beli/create",
              },
            },
            {
              icon: "chevron",
              text: "Tarik Saldo",
              path: "ibos",
              query: {
                part: "paylink/info/v2?withdraw=true",
              },
            },
            {
              icon: "chevron",
              text: "Riwayat Pembelian Saldo",
              path: "ibos",
              query: {
                part: "paylink/beli",
              },
            },
            {
              icon: "chevron",
              text: "Riwayat Pemasukan",
              path: "ibos",
              query: {
                part: "paylink/payment",
              },
            },
          ],
        },
        {
          icon: "bantuan-icon-rounded",
          text: "Bantuan & Kampus Smartlink ",
          path: "",
          children: [
            //     {
            //     icon: 'chevron',
            //     text: 'Pusat Bantuan',
            //     path: 'ibos',
            //     query: {
            //         part: '/'
            //     },
            // }, {
            //     icon: 'chevron',
            //     text: 'FAQ',
            //     path: 'ibos',
            //     query: {
            //         part: '/'
            //     },
            // }, {
            //     icon: 'chevron',
            //     text: 'Ulangi Panduan',
            //     path: 'ibos',
            //     query: {
            //         part: '/'
            //     },
            // },
            {
              icon: "chevron",
              text: "Hubungi Kami",
              path: "bantuan",
              query: {
                part: "/",
              },
            },
            {
              icon: "chevron",
              text: "Kampus Smartlink",
              path: "training.list",
            },
          ],
        },
        {
          icon: "adjustments",
          text: "Pengaturan Umum",
          isNew: true,
          path: "pengaturanUmum.dashboard",
        },
        {
          icon: "outlet-sidebar",
          text: "Outlet & Workshop",
          path: "addoutlet",
        },
        {
          icon: "karyawan-sidebar",
          text: "Karyawan & Absensi",
          path: "karyawan",
        },
        {
          icon: "gaji",
          text: "Penggajian, Komisi & Kasbon",
          path: "AddPenggajian",
        },
        {
          icon: "pelanggan",
          text: "Konsumen",
          // path: 'ibos',
          // query: {
          //     part: 'konsumen'
          // },
          path: "konsumen",
        },
        // {
        //   icon: "pelanggan",
        //   text: "Konsumen - Versi Lama",
        //   path: "ibos",
        //   query: {
        //     part: "konsumen",
        //   },
        //   // path: 'konsumen',
        // },
        {
          icon: "transaksi",
          text: "Transaksi & Pembatalan",
          path: "TransaksiDanPenghapusan",
        },
        // {
        //     icon: "transaksi",
        //     text: "Transaksi & Pembatalan",
        //     children: [
        //         {
        //             icon: "chevron",
        //             text: "Rekap Transaksi",
        //             path: "",
        //             children: [
        //                 {
        //                     icon: "chevron",
        //                     text: "Transaksi Reguler",
        //                     path: "ibos",
        //                     query: {
        //                         part: "transaksi/transaksi",
        //                     },
        //                 },
        //                 {
        //                     icon: "chevron",
        //                     text: "Transaksi Snapclean",
        //                     path: "ibos",
        //                     query: {
        //                         part: "transaksi/snapclean",
        //                     },
        //                 },
        //                 {
        //                     icon: "chevron",
        //                     text: "Topup Deposit",
        //                     path: "ibos",
        //                     query: {
        //                         part: "transaksi/deposit",
        //                     },
        //                 },
        //                 {
        //                     icon: "chevron",
        //                     text: "Topup Emoney",
        //                     path: "ibos",
        //                     query: {
        //                         part: "transaksi/emoney",
        //                     },
        //                 },
        //             ],
        //         },
        //         {
        //             icon: "chevron",
        //             text: "Permintaan Pembatalan",
        //             path: "",
        //             children: [
        //                 {
        //                     icon: "chevron",
        //                     text: "Pembatalan Transaksi Reguler",
        //                     path: "ibos",
        //                     query: {
        //                         part: "transaksi/pembatalan/outlet",
        //                     },
        //                 },
        //                 {
        //                     icon: "chevron",
        //                     text: "Pembatalan Transaksi Snapclean",
        //                     path: "ibos",
        //                     query: {
        //                         part: "transaksi/snapclean/pembatalan",
        //                     },
        //                 },
        //                 {
        //                     icon: "chevron",
        //                     text: "Pembatalan Topup Deposit",
        //                     path: "ibos",
        //                     query: {
        //                         part: "transaksi/pembatalan/deposit",
        //                     },
        //                 },
        //                 {
        //                     icon: "chevron",
        //                     text: "Pembatalan Topup Emoney",
        //                     path: "ibos",
        //                     query: {
        //                         part: "transaksi/pembatalan/emoney",
        //                     },
        //                 },
        //             ],
        //         },
        //     ],
        // },
        // keuangan old
        // {
        //   icon: "keuangan",
        //   text: "Keuangan",
        //   path: "",
        //   children: [
        //     {
        //       icon: "chevron",
        //       text: "Data Akun",
        //       path: "ibos",
        //       query: {
        //         part: "keuangan/akun",
        //       },
        //     },
        //     {
        //       icon: "chevron",
        //       text: "Setoran Masuk",
        //       path: "",
        //       children: [
        //         {
        //           icon: "chevron",
        //           text: "Setoran Outlet",
        //           path: "ibos",
        //           query: {
        //             part: "keuangan/setoran/outlet",
        //           },
        //         },
        //         {
        //           icon: "chevron",
        //           text: "Setoran Workshop",
        //           path: "ibos",
        //           query: {
        //             part: "keuangan/setoran/workshop",
        //           },
        //         },
        //       ],
        //     },
        //     {
        //       icon: "chevron",
        //       text: "Pengeluaran Biaya",
        //       path: "",
        //       children: [
        //         {
        //           icon: "chevron",
        //           text: "Biaya Outlet",
        //           path: "ibos",
        //           query: {
        //             part: "keuangan/biaya/outlet",
        //           },
        //         },
        //         {
        //           icon: "chevron",
        //           text: "Biaya Workshop",
        //           path: "ibos",
        //           query: {
        //             part: "keuangan/biaya/workshop",
        //           },
        //         },
        //       ],
        //     },
        //     {
        //       icon: "chevron",
        //       text: "Permintaan Kas Laci",
        //       path: "",
        //       children: [
        //         {
        //           icon: "chevron",
        //           text: "Permintaan Outlet",
        //           path: "ibos",
        //           query: {
        //             part: "keuangan/transfer/outlet",
        //           },
        //         },
        //         {
        //           icon: "chevron",
        //           text: "Permintaan Workshop",
        //           path: "ibos",
        //           query: {
        //             part: "keuangan/transfer/workshop",
        //           },
        //         },
        //       ],
        //     },
        //     {
        //       icon: "chevron",
        //       text: "Setoran Modal",
        //       path: "ibos",
        //       query: {
        //         part: "keuangan/modal",
        //       },
        //     },
        //     {
        //       icon: "chevron",
        //       text: "Pengambilan Prive",
        //       path: "ibos",
        //       query: {
        //         part: "keuangan/prive",
        //       },
        //     },
        //     {
        //       icon: "chevron",
        //       text: "Transfer Kas Bank",
        //       path: "ibos",
        //       query: {
        //         part: "keuangan/kasbank",
        //       },
        //     },
        //     {
        //       icon: "chevron",
        //       text: "Entry Keuangan Manual",
        //       path: "ibos",
        //       query: {
        //         part: "keuangan/entry",
        //       },
        //     },
        //   ],
        // },
        // keuangan new
        {
          icon: "keuangan",
          text: "Keuangan",
          isNew: true,
          path: "",
          children: [
            {
              icon: "chevron",
              text: "Data Akun",
              path: "ibos",
              query: {
                part: "keuangan/akun",
              },
            },
            {
              icon: "chevron",
              text: "Rekening Bank & EDC",
              path: "",
              children: [
                {
                  icon: "chevron",
                  text: "Rekening Bank",
                  path: "RekeningBank.List",
                },
                {
                  icon: "chevron",
                  text: "Mesin EDC",
                  path: "mesin.edc.list",
                },
              ],
            },
            {
              icon: "chevron",
              text: "Setoran Masuk",
              isNew: true,
              path: "",
              children: [
                {
                  icon: "chevron",
                  text: "Settlement EDC",
                  path: "SettlementEdcGlobal",
                },
                {
                  icon: "chevron",
                  isNew: true,
                  text: "Setoran Kas Outlet",
                  path: "SetoranKasOutlet",
                },
                {
                  icon: "chevron",
                  isNew: true,
                  text: "Setoran Kas Workshop",
                  path: "SetoranKasWorkshop",
                },
              ],
            },
            {
              icon: "chevron",
              text: "Pengeluaran Biaya",
              isNew: true,
              path: "",
              children: [
                {
                  icon: "chevron",
                  text: "Biaya Outlet",
                  isNew: true,
                  path: "BiayaOutlet",
                },
                {
                  icon: "chevron",
                  text: "Biaya Workshop",
                  isNew: true,
                  path: "BiayaWorkshop",
                },
              ],
            },
            {
              icon: "chevron",
              text: "Permintaan Kas Laci",
              isNew: true,
              path: "",
              children: [
                {
                  icon: "chevron",
                  text: "Permintaan Outlet",
                  isNew: true,
                  path: "PermintaanKasOutlet",
                },
                {
                  icon: "chevron",
                  isNew: true,
                  text: "Permintaan Workshop",
                  path: "PermintaanKasWorkshop",
                },
              ],
            },
            {
              icon: "chevron",
              text: "Setoran Modal",
              path: "ibos",
              query: {
                part: "keuangan/modal",
              },
            },
            {
              icon: "chevron",
              text: "Pengambilan Prive",
              path: "ibos",
              query: {
                part: "keuangan/prive",
              },
            },
            {
              icon: "chevron",
              text: "Transfer Kas Bank",
              path: "ibos",
              query: {
                part: "keuangan/kasbank",
              },
            },
            {
              icon: "chevron",
              text: "Entry Keuangan Manual",
              path: "ibos",
              query: {
                part: "keuangan/entry",
              },
            },
          ],
        },
        {
          icon: "laporan",
          text: "Laporan",
          path: "",
          children: [
            {
              icon: "chevron",
              text: "Jurnal",
              path: "ibos",
              query: {
                part: "laporan/keuangan/jurnal",
              },
            },
            {
              icon: "chevron",
              text: "Buku Besar",
              path: "ibos",
              query: {
                part: "laporan/keuangan/bukubesar",
              },
            },
            {
              icon: "chevron",
              text: "Labarugi",
              path: "ibos",
              query: {
                part: "laporan/keuangan/labarugi",
              },
            },
            {
              icon: "chevron",
              text: "Perubahan Modal",
              path: "ibos",
              query: {
                part: "laporan/keuangan/modal",
              },
            },
            {
              icon: "chevron",
              text: "Neraca",
              path: "ibos",
              query: {
                part: "laporan/keuangan/neraca",
              },
            },
          ],
        },
        {
          icon: "performa",
          text: "Performa Usaha",
          path: "",
          children: [
            {
              icon: "chevron",
              text: "Performa Outlet",
              path: "ibos",
              query: {
                part: "laporan/performa/outlet",
              },
            },
            {
              icon: "chevron",
              text: "Performa Karyawan",
              path: "ibos",
              query: {
                part: "karyawan/performa",
              },
            },
            {
              icon: "chevron",
              text: "Grafik Pendapatan",
              path: "ibos",
              query: {
                part: "laporan/grafik/pendapatan",
              },
            },
            {
              icon: "chevron",
              text: "Grafik Biaya",
              path: "ibos",
              query: {
                part: "laporan/grafik/biaya",
              },
            },
          ],
        },
        {
          icon: "afiliasi",
          text: "Afiliasi",
          path: "afiliasi.welcome_page",
        },

        {
          icon: "investor",
          text: "Investor",
          path: "",
          children: [
            {
              icon: "chevron",
              text: "Data Investor",
              path: "ibos",
              query: {
                part: "investor/member",
              },
            },
            {
              icon: "chevron",
              text: "Bagi Hasil",
              path: "ibos",
              query: {
                part: "investor/settlement",
              },
            },
          ],
        },

        {
          icon: "snk",
          text: "Syarat & Ketentuan",
          path: "tos",
        },
        {
          icon: "afiliasi",
          text: "Reset Transaksi & Keuangan",
          path: "ibos",
          query: {
            part: "setting/reset",
          },
        },
        {
          icon: "chevron",
          text: "Logout / Keluar",
          path: "logout",
        },
      ],
      modalBeta: false,
      clicks: 0,
    };
  },
  mounted() {
    let widthScreen = window.screen.width;
    if (widthScreen > 768) {
      $("body").addClass("body-open");

      this.device = "desktop";
      this.show_menu = true;
      this.items.unshift({
        icon: "outlet-sidebar",
        text: "Dashboard",
        path: "dashboard",
      });
      $(".view-screen").css(
        "cssText",
        "margin: 0px auto 0px 350px;  width: auto;"
      );
      $(".header-top").css("cssText", "margin: 0px auto 0px 0px; width: auto;");
    } else {
      this.device = "mobile";
    }

    $(".navbar-item").removeClass("active");
    $(".navbar-item." + this.$route.name).addClass("active");
    if (this.show_menu) {
      $(".sidebar-menu").show();
    }
    this.getdetailowner();
  },
  watch: {
    "$route.name": {
      handler: function (routeName) {
        $(".navbar-item").removeClass("active");
        $(".navbar-item." + routeName).addClass("active");
      },
      deep: true,
      immediate: true,
    },

    show_menu: function (val, oldVal) {
      $(".sidebar-menu").show();
      if (this.show_menu) {
        if (this.device === "mobile") {
          $(".view-screen").hide();
        } else {
          $(".view-screen").css({ "margin-left": "350px" });
          let el = document.getElementsByClassName("responsive-item");
          el.forEach((element) => {
            element.classList.add("set-responsive");
          });
        }
        this.fadeAnimated = "fadeInUpBig faster";
      } else {
        if (this.device !== "mobile") {
          $(".view-screen").css({ "margin-left": "0px" });
          let el = document.getElementsByClassName("responsive-item");
          el.forEach((element) => {
            element.classList.remove("set-responsive");
          });
        }
        $(".view-screen").show();
        this.fadeAnimated = "fadeOutDownBig";
        setTimeout(() => {
          $(".sidebar-menu").hide();
        }, 500);
      }
    },
  },
  methods: {
    isShowBeta(feature) {
      if ("betaKey" in feature) {
        return this.$store.state.metaModule.betaFeatureOwnerAccess.feature.includes(
          feature.betaKey
        );
      } else {
        return true;
      }
    },
    async getdetailowner() {
      try {
        const response = await this.$axios.get(
          this.$baseurl + "/masterData/meta/data_detail_owner",
          this.requestHeaders
        );
        if (response.data.status === true) {
          this.owner = response.data.data;
        }
      } catch (e) {
        if (!e.code) {
          this.popupType = "error";
          this.popupErrorException = e;
        }
      }
    },
    add(event) {},
    toogleMenu() {
      if (this.show_menu) {
        this.closeMenu();
      } else {
        this.showMenu();
      }
    },

    showMenu() {
      $("body").addClass("body-open");
      $("#nav-bottom").addClass("is-open");
      this.show_menu = true;
    },
    closeMenu() {
      $("body").removeClass("body-open");
      $("#nav-bottom").removeClass("is-open");
      this.show_menu = false;
    },
    getImgUrl(pic) {
      return require("../../assets/icon-sidebar/" + pic + ".svg");
    },
    contactCS() {
      if (this.owner != null) {
        window.location.href =
          "https://api.whatsapp.com/send/?phone=6285234494494&text=Halo%20SmartCare" +
          "%2C%0Asaya%20" +
          this.owner.nama +
          "%0Aemail%20%3A%20" +
          this.owner.email +
          "%20%0Atelp%20%3A%20" +
          this.owner.telp +
          "%20%0AIngin Bertanya:" +
          "%20%0A ";
      } else {
        window.open("https://Wa.me/6285234494494");
      }
    },
    clickMenu(routeName) {
      this.clicks++;

      if (this.clicks === 20) {
        this.clicks = 0;
        this.modalBeta = true;
      }

      if (this.device === "mobile") {
        this.closeMenu();
      }
      routeName = "/" + routeName;
      if (this.$route.path !== routeName) {
        this.$router.push(routeName);
      } else {
        window.location.reload();
      }
    },
    clickItem(index, item) {
      if (item.children) {
        if (item.active) {
          item.active = false;
        } else {
          item.active = true;
        }
        this.$forceUpdate();
      } else {
        if (this.device === "mobile") {
          this.closeMenu();
        }

        switch (item.path) {
          case "bantuan":
            if (this.owner != null) {
              window.location.href =
                "https://api.whatsapp.com/send/?phone=6285234494494&text=Halo%20SmartCare" +
                "%2C%0Asaya%20" +
                this.owner.nama +
                "%0Aemail%20%3A%20" +
                this.owner.email +
                "%20%0Atelp%20%3A%20" +
                this.owner.telp +
                "%20%0AIngin Bertanya:" +
                "%20%0A ";
            } else {
              window.open("https://wa.me/6285234494494", "_blank");
            }
            this.smartTrackingClickMenu("bantuan");
            break;
          case "notifikasi":
            this.$parent.RouteToNotification();
            this.smartTrackingClickMenu("notifikasi");
            break;
          case "ibos":
            item.query.label = item.text;
            this.$router.push({ name: item.path, query: item.query });

            // this.smartTrackingClick("mn_to_"+item.path+"_"+item.query.part);

            this.smartTrackingClickMenu(
              item.text.replaceAll(" ", "_").toLowerCase()
            );

            break;
          case "tos":
            window.open("https://smartlink.id/syarat-ketentuan-layanan");
            this.smartTrackingClickMenu("tos");
            break;
          case "logout":
            this.logoutApp();
            this.smartTrackingClickMenu("logout");
            break;
          case "switchToBeta":
            this.$store.commit("metaModule/setOpenBetaModal", true);
            this.smartTrackingClickMenu("switchBeta");
            break;
          default:
            if (this.$route.name !== item.path) {
              this.$router.push({ name: item.path });
            } else {
              window.location.reload();
            }
            let event_track_name = item.text.replaceAll(" ", "_").toLowerCase();
            this.smartTrackingClickMenu(event_track_name);

            break;
        }
      }
    },
    async logoutApp() {
      try {
        const forms = new FormData();
        forms.append("idowner", localStorage.getItem("idowner"));
        forms.append("token", localStorage.getItem("token"));
        const response = await this.$axios.post(
          this.$baseurl + "/masterData/dashboard/logout_owner_token",
          forms
        );
        if (response.data.code === 200) {
          if (response.data.status === true) {
            var myItem = localStorage.getItem("incontext-device");
            let kodeAfiliasi = localStorage.getItem("kode_afiliasi");
            localStorage.clear();
            localStorage.setItem("incontext-device", myItem);
            if (kodeAfiliasi) {
              localStorage.setItem("kode_afiliasi", kodeAfiliasi);
            }
            if (this.getUserAgent() !== "ios") {
              if (
                localStorage.getItem("remember-token-firebase") !== null ||
                localStorage.getItem("remember-token-firebase") === "undefined"
              ) {
                try {
                  const messaging = firebaseToken.messaging();
                  await messaging.deleteToken();
                } catch (e) {
                  // ignore
                }
              }
            }
            this.$router.push("/login");
          } else {
            this.$toast.error(response.data.msg);
          }
        } else {
          this.$toast.error(response.data.msg);
        }
      } catch (e) {
        this.$catch_error_response(e);
      }
    },
  },
};
</script>
<style scoped>
.second-level,
.third-level {
  padding-left: 20px;
}
.menu-box-text {
  text-decoration: none;
  color: #000;
}
.new-menu-flag {
  color: #206cff;
  background-color: #e2f0ff;
  padding: 4px;
  border-radius: 4px;
  margin-left: 8px;
}
.switchToBeta {
  /*display: none !important;*/
}
</style>
